
import { Component, Watch, Vue } from "vue-property-decorator";
import { RevenueList } from "./RevenueList.vue";
import {
  TimesheetFilterQueryPayload,
  TimesheetAllPayload,
  Revenue,
  Technician,
  MR,
} from "@/store/modules";
import { CDataTableSortVal } from "@/@types";
import { queryFilterHasChange, filterEmptyQuery } from "@/utility";
import { SortQueryPayload } from "@/store/modules";
import TechnicianMultiDropdown from "@/pages/technician/filters/TechnicianMultiDropdown.vue";
import MRMultiDropdown from "@/pages/mr/filters/MRMultiDropdown.vue";
import RevenueListHandler from './RevenueListHandler.vue';

@Component({
  components: { RevenueList, TechnicianMultiDropdown, MRMultiDropdown, RevenueListHandler },
})
export default class RevenueListPage extends Vue {
  limit = 25;

  colFilter: TimesheetFilterQueryPayload = {
    startDate: "",
    endDate: "",
  };

  currentPage = 1;

  sort: SortQueryPayload = {
    sort: "total",
    order: "desc",
  };

  sortVal: CDataTableSortVal = {};

  // @Model("tech-select", { type: Array, default: () => [] })
  filterTechs!: Technician[];

  filterMR!: MR[];

  debounceTimeout?: NodeJS.Timeout;

  /**
   * in ms
   */
  debounceTime = 1000;

  @Watch("colFilter", { deep: true })
  onColFilterChange(
    val: TimesheetFilterQueryPayload | null,
    oldVal: TimesheetFilterQueryPayload | null
  ) {
    if (!val || !oldVal) {
      return;
    }
    console.log(
      "p",
      val,
      oldVal,
      queryFilterHasChange<TimesheetFilterQueryPayload>(val, oldVal)
    );
    if (queryFilterHasChange<TimesheetFilterQueryPayload>(val, oldVal)) {
      this.load();
    }
  }

  @Watch("limit")
  onLimitChange(val: number, oldVal: number) {
    if (val !== oldVal) {
      this.load();
    }
  }

  @Watch("sortVal")
  onSortValChange(val: CDataTableSortVal, oldVal: CDataTableSortVal) {
    this.sort = {
      sort: val.column || "total",
      order: val.asc ? "asc" : "desc",
    };
    console.log(this.sort);
    this.load();
  }

  mounted() {
    this.load();
  }

  load(debounce = false) {
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }

    if (!debounce) {
      this.$nextTick(() => this.fetchRender(this.compilePayload()));
    }

    this.debounceTimeout = setTimeout(
      () => this.$nextTick(() => this.fetchRender(this.compilePayload())),
      this.debounceTime
    );
  }

  async fetchRender(payload: TimesheetAllPayload) {
    await Revenue.dispatch("all", payload);
  }

  get items(): Array<any> {
    const data = Revenue.query().withAll().get();
    return data;
  }

  get loading(): boolean {
    return !!Revenue.store().state.entities.revenue.fetching;
  }

  get total() {
    return Revenue.store().state.entities.revenue.total;
  }

  get numPages(): number {
    const total = Revenue.store().state.entities.revenue.total;

    if (!total) {
      return 0;
    }
    // console.log('t', Math.ceil(total / this.limit), 1);
    return Math.max(Math.ceil(total / this.limit), 1);
  }

  get totalHours(): number {
    return Revenue.store().state.entities.revenue.revenue;
  }

  onPageChange(page: number) {
    this.$nextTick(() =>
      this.fetchRender(
        this.compilePayload({
          offset: Math.floor(this.limit * (page - 1)),
        })
      )
    );
  }

  compilePayload(
    merge: Partial<TimesheetAllPayload> = {}
  ): TimesheetAllPayload {
    return {
      limit: this.limit,
      offset: Math.floor(this.limit * (this.currentPage - 1)),
      ...this.sort,
      ...{ filter: this.compileFilter() },
      ...merge,
    };
  }

  compileFilter(): TimesheetAllPayload["filter"] {
    const f = filterEmptyQuery(this.colFilter);
    const timeRange = [];
    if (this.colFilter.startDate || this.colFilter.endDate) {
      timeRange.push(this.colFilter.startDate || "");
      timeRange.push(
        this.colFilter.endDate || new Date(Date.now()).toISOString()
      );
      delete f.startDate;
      delete f.endDate;
    }

    if (timeRange.length) {
      f.timeRange = timeRange.join(",");
    }

    if (this.filterTechs && this.filterTechs.length) {
      f.techID = (this.filterTechs || []).map((tech) => tech.ID).join(",");
    }

    if (this.filterMR && this.filterMR.length) {
      f.mrID = (this.filterMR || []).map((mr) => mr.id).join(",");
    }

    // f.voided = 0;

    f.status = "approved";

    return { ...f };
  }

  onTechSelect(options: Technician[]) {
    this.filterTechs = options;

    this.load(true);
  }

  onMR(options: MR[]) {
    this.filterMR = options;
    this.load(true);
  }
}
